import styled, { css } from 'styled-components'

export const Controls = styled.div`
  ${({ theme }) => css`
    position: absolute;
    right: 0.75rem;
    bottom: 0.75rem;
    z-index: 4;
    display: flex;
    align-items: center;
    padding: 0.2rem;
    background: ${theme.colors.white};
    border-radius: ${theme.border.radius.large};
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.2);
    opacity: 0;
    pointer-events: none;
    transition: opacity 160ms ease-out;
  `}
`

export const Root = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  min-height: 0;
  container-type: size;

  &:hover ${Controls}, &:focus-within ${Controls} {
    opacity: 1;
    pointer-events: auto;
  }

  @media (hover: none) {
    ${Controls} {
      opacity: 1;
      pointer-events: auto;
    }
  }
`

export const ControlButton = styled.button`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 2.25rem;
    height: 2.25rem;
    border: none;
    background: transparent;
    color: ${theme.colors.dark};
    cursor: pointer;

    svg {
      font-size: 1.1rem;
    }
  `}
`

export const Image = styled.img`
  display: block;
  width: auto;
  height: auto;
  max-width: calc(100cqw - 2rem);
  max-height: calc(100cqh - 2rem);
  object-fit: contain;
`
